export default {
  notification: "",
  type: "",
  notification_stream: [],
  notification_all: {},
};
